import React, { Component } from "react";
import { Modal } from "react-bootstrap";

class PreviewModal extends Component {
  render() {
    const { title, url, showModal, onHideModal } = this.props;
    return (
      <Modal
        dialogClassName="preview-modal"
        backdrop="static"
        show={showModal}
        onHide={onHideModal}
        className="preview-modal-content"
      >
        <Modal.Header>
          <div className="row">
            <div className="col-xs-8">
              <h4>{title}</h4>
            </div>
            <div className="col-xs-4">
              <button onClick={onHideModal} className="btn btn-default pull-right">
                Close Preview
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body style={{ height: "90%" }}>
          <iframe
            frameBorder="0"
            style={{ overflow: "hidden", height: "100%", width: "100%" }}
            height="100%"
            width="100%"
            title={title}
            src={url}
          ></iframe>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button onClick={this.props.onHideModal}>Close</Button>
        </Modal.Footer> */}
      </Modal>
    );
  }
}

export default PreviewModal;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Common/PreviewModal.js